import { Route, Switch } from "react-router-dom";

import TopShopDelayWindowPage from "../../workspace/mp/top-shop-delay-window";

export function MehulPillaiRoutes() {
  return (
    <Switch>
      <Route
        path="/mp/top-shop-delay-window"
        component={TopShopDelayWindowPage}
      />
    </Switch>
  );
}

export const slug = "mp";
